const API_BASE_URL = 'https://sh-tenderhut-api.azurewebsites.net/';

export const API_URL = {
  CONTACT: `${API_BASE_URL}contact`
};



// WEBPACK FOOTER //
// ./src/common/consts/api.js